import { render, staticRenderFns } from "./SearchCategory.vue?vue&type=template&id=0f3b55a4&scoped=true"
import script from "./SearchCategory.vue?vue&type=script&lang=js"
export * from "./SearchCategory.vue?vue&type=script&lang=js"
import style0 from "./SearchCategory.vue?vue&type=style&index=0&id=0f3b55a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b55a4",
  null
  
)

export default component.exports